<template>
  <CHeader fixed with-subheader light>
    <CHeaderBrand to="/app/color">
      <img src="/app/color/logo-font.svg" height="27" alt="Logo" class="ml-2"/>
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/app/color/users" exact>
          ユーザーリスト
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/app/color/users/1" exact>
          マイアカウント
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/app/color" exact>
          ログアウト
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>
  </CHeader>
</template>

<script>
export default {
  name: 'TheHeader',
  methods: {
    goMyAccount () {
      this.$router.push({path: `/app/color/users/${localStorage.userId}`});
    }
  }
}
</script>
